/** Static Figma Admin Arts Genome fixtures (`40005284:94804`). */

export const ARTS_GENOME_KPI = [
  {
    key: "spellbook",
    title: "Spellbook Categories",
    value: "5",
    tone: "lightblue-custom",
  },
  {
    key: "class",
    title: "Class Types",
    value: "5",
    tone: "lightteal",
  },
  {
    key: "keyword",
    title: "Keyword Mappings",
    value: "248",
    tone: "purple-custom",
  },
]

export const ARTS_GENOME_TABS = [
  { key: "spellbook", label: "Spellbook" },
  { key: "class", label: "Class" },
  { key: "keyword", label: "Keyword Mapping" },
]

export const TAB_CONFIG = {
  spellbook: {
    rowsKey: "spellbook",
    nameHeader: "Spellbook",
    addLabel: "Add Category",
    searchPlaceholder: "Search by title...",
    paginationLabel: "Categories",
    filterLabel: "Category",
    filterOptions: [
      { value: "music", label: "Music" },
      { value: "film", label: "Film" },
      { value: "visual-arts", label: "Visual Arts" },
      { value: "performing-arts", label: "Performing Arts" },
      { value: "literary", label: "Literary" },
    ],
  },
  class: {
    rowsKey: "class",
    nameHeader: "Class",
    addLabel: "Add Class Type",
    searchPlaceholder: "Search by title...",
    paginationLabel: "Class Types",
    filterLabel: "Class Type",
    filterOptions: [
      { value: "creator", label: "Creator" },
      { value: "organizer", label: "Organizer" },
      { value: "supporter", label: "Supporter" },
      { value: "educator", label: "Educator" },
      { value: "curator", label: "Curator" },
    ],
  },
  keyword: {
    rowsKey: "keyword",
    nameHeader: "Role (Internal)",
    secondaryHeader: "Public Role",
    addLabel: "Add Mapping",
    searchPlaceholder: "Search by title...",
    paginationLabel: "Mappings",
    filterLabel: "Category",
    filterOptions: [
      { value: "music", label: "Music" },
      { value: "film", label: "Film" },
      { value: "visual-arts", label: "Visual Arts" },
      { value: "performing-arts", label: "Performing Arts" },
      { value: "literary", label: "Literary" },
    ],
    columns: [
      { key: "roleInternal", label: "Role (Internal)" },
      { key: "publicRole", label: "Public Role" },
      {
        key: "spellbook",
        label: "Spellbook",
        type: "spellbook-pill",
        toneKey: "spellbookSlug",
      },
      {
        key: "spellbookSecondary",
        label: "Spellbook Secondary",
        type: "spellbook-pill",
        toneKey: "spellbookSecondarySlug",
      },
      {
        key: "classPrimary",
        label: "Class",
        type: "class-pill",
        toneKey: "classSlug",
      },
      {
        key: "classSecondary",
        label: "Class Secondary",
        type: "class-pill",
        toneKey: "classSecondarySlug",
      },
      { key: "status", label: "Status", type: "status" },
      { key: "createdAt", label: "Created At" },
    ],
  },
}

const getInitials = name =>
  (name || "")
    .split(/\s+/)
    .filter(Boolean)
    .map(part => part.charAt(0))
    .join("")
    .slice(0, 2)
    .toUpperCase()

export const SPELLBOOK_ROWS = [
  {
    id: "1",
    slug: "music",
    name: "Music",
    initials: "MU",
    createdAt: "Jun 15, 2025 05:00 PM",
    uploadedAt: "Jun 15, 2025 05:10 PM",
  },
  {
    id: "2",
    slug: "film",
    name: "Film",
    initials: "FI",
    createdAt: "Jan 25, 2026 07:30 PM",
    uploadedAt: "Jan 25, 2026 07:45 PM",
  },
  {
    id: "3",
    slug: "visual-arts",
    name: "Visual Arts",
    initials: "VA",
    createdAt: "Mar 08, 2025 02:15 PM",
    uploadedAt: "Mar 08, 2025 02:20 PM",
  },
  {
    id: "4",
    slug: "performing-arts",
    name: "Performing Arts",
    initials: "PA",
    createdAt: "Apr 22, 2025 11:00 AM",
    uploadedAt: "Apr 22, 2025 11:05 AM",
  },
  {
    id: "5",
    slug: "literary",
    name: "Literary",
    initials: "LI",
    createdAt: "Dec 01, 2025 09:00 AM",
    uploadedAt: "Dec 01, 2025 09:10 AM",
  },
]

export const CLASS_ROWS = [
  {
    id: "1",
    slug: "creator",
    name: "Creator",
    initials: "CR",
    createdAt: "May 10, 2025 03:00 PM",
    uploadedAt: "May 10, 2025 03:05 PM",
  },
  {
    id: "2",
    slug: "organizer",
    name: "Organizer",
    initials: "OR",
    createdAt: "May 10, 2025 03:10 PM",
    uploadedAt: "May 10, 2025 03:12 PM",
  },
  {
    id: "3",
    slug: "supporter",
    name: "Supporter",
    initials: "SU",
    createdAt: "May 11, 2025 10:00 AM",
    uploadedAt: "May 11, 2025 10:05 AM",
  },
  {
    id: "4",
    slug: "educator",
    name: "Educator",
    initials: "ED",
    createdAt: "Jun 02, 2025 01:30 PM",
    uploadedAt: "Jun 02, 2025 01:35 PM",
  },
  {
    id: "5",
    slug: "curator",
    name: "Curator",
    initials: "CU",
    createdAt: "Jun 02, 2025 01:40 PM",
    uploadedAt: "Jun 02, 2025 01:42 PM",
  },
]

const KEYWORD_MAPPING_SEEDS = [
  {
    roleInternal: "creator",
    publicRole: "Creator",
    spellbook: "Music",
    spellbookSlug: "music",
    spellbookSecondary: "Jazz",
    classPrimary: "creator",
    classSecondary: "Jazz",
    status: "active",
    createdAt: "Jun 15, 2025 05:00 PM",
  },
  {
    roleInternal: "organizer",
    publicRole: "Organizer",
    spellbook: "Film",
    spellbookSlug: "film",
    spellbookSecondary: "Documentary",
    classPrimary: "organizer",
    classSecondary: "Documentary",
    status: "active",
    createdAt: "Jan 25, 2026 07:30 PM",
  },
  {
    roleInternal: "supporter",
    publicRole: "Supporter",
    spellbook: "Visual Arts",
    spellbookSlug: "visual-arts",
    spellbookSecondary: "Painting",
    classPrimary: "supporter",
    classSecondary: "Painting",
    status: "active",
    createdAt: "Mar 08, 2025 02:15 PM",
  },
  {
    roleInternal: "educator",
    publicRole: "Educator",
    spellbook: "Performing Arts",
    spellbookSlug: "performing-arts",
    spellbookSecondary: "Theatre",
    classPrimary: "educator",
    classSecondary: "Theatre",
    status: "active",
    createdAt: "Apr 22, 2025 11:00 AM",
  },
  {
    roleInternal: "curator",
    publicRole: "Curator",
    spellbook: "Literary",
    spellbookSlug: "literary",
    spellbookSecondary: "Poetry",
    classPrimary: "curator",
    classSecondary: "Poetry",
    status: "active",
    createdAt: "Dec 01, 2025 09:00 AM",
  },
]

const KEYWORD_SECONDARY_VARIANTS = [
  "Jazz",
  "Documentary",
  "Painting",
  "Theatre",
  "Poetry",
  "Orchestra",
  "Animation",
  "Sculpture",
  "Dance",
  "Novel",
]

const buildKeywordMappingRows = () => {
  const rows = []

  for (let index = 0; index < 248; index += 1) {
    const seed = KEYWORD_MAPPING_SEEDS[index % KEYWORD_MAPPING_SEEDS.length]
    const secondary =
      KEYWORD_SECONDARY_VARIANTS[index % KEYWORD_SECONDARY_VARIANTS.length]
    const suffix =
      index >= KEYWORD_MAPPING_SEEDS.length
        ? ` ${Math.floor(index / KEYWORD_MAPPING_SEEDS.length) + 1}`
        : ""
    const roleInternal =
      index >= KEYWORD_MAPPING_SEEDS.length
        ? `${seed.roleInternal}${suffix}`.trim()
        : seed.roleInternal

    rows.push({
      id: String(index + 1),
      roleInternal,
      publicRole: seed.publicRole + (suffix ? suffix : ""),
      spellbook: seed.spellbook,
      spellbookSlug: seed.spellbookSlug,
      spellbookSecondary:
        index < KEYWORD_MAPPING_SEEDS.length ? seed.spellbookSecondary : secondary,
      classPrimary: seed.classPrimary,
      classSecondary:
        index % 7 === 6 ? null : index < KEYWORD_MAPPING_SEEDS.length
          ? seed.classSecondary
          : secondary,
      status: index % 11 === 10 ? "inactive" : "active",
      createdAt: seed.createdAt,
    })
  }

  return rows
}

export const KEYWORD_ROWS = buildKeywordMappingRows()

export const SPELLBOOK_PILL_TONES = {
  music: "music",
  film: "film",
  "visual-arts": "visual-arts",
  "visual-art": "visual-arts",
  "performing-arts": "performing-arts",
  "performing-art": "performing-arts",
  literary: "literary",
  sound: "sound",
}

/** Soft class chips on Keyword Mapping (Creator, Technician, etc.). */
export const CLASS_PILL_TONES = {
  creator: "creator",
  technician: "technician",
  artist: "artist",
  coordinator: "coordinator",
  organizer: "organizer",
  supporter: "supporter",
  educator: "educator",
  curator: "curator",
}

/** Normalize API slug / label → pill tone key. */
export const normalizePillToneKey = value =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")

export const resolveSpellbookPillTone = (slugOrName = "") => {
  const key = normalizePillToneKey(slugOrName)
  return SPELLBOOK_PILL_TONES[key] || "neutral"
}

export const resolveClassPillTone = (slugOrName = "") => {
  const key = normalizePillToneKey(slugOrName)
  return CLASS_PILL_TONES[key] || "neutral"
}

export const ARTS_GENOME_ROWS = {
  spellbook: SPELLBOOK_ROWS,
  class: CLASS_ROWS,
  keyword: KEYWORD_ROWS,
}

export const ARTS_GENOME_TYPES = ["spellbook", "class", "keyword"]

export const MAPPED_TO_OPTIONS = SPELLBOOK_ROWS.map(row => ({
  value: row.slug,
  label: row.name,
}))

export const PUBLIC_ROLE_OPTIONS = CLASS_ROWS.map(row => ({
  value: row.slug,
  label: row.name,
}))

export const SPELLBOOK_SELECT_OPTIONS = SPELLBOOK_ROWS.map(row => ({
  value: row.slug,
  label: row.name,
}))

export const CLASS_SELECT_OPTIONS = CLASS_ROWS.map(row => ({
  value: row.slug,
  label: row.name,
}))

const buildSecondaryOptions = values =>
  values.map(value => ({
    value,
    label: value,
  }))

export const SPELLBOOK_SECONDARY_OPTIONS = buildSecondaryOptions(
  KEYWORD_SECONDARY_VARIANTS,
)

export const CLASS_SECONDARY_OPTIONS = buildSecondaryOptions(
  KEYWORD_SECONDARY_VARIANTS,
)

export const FORM_CONFIG = {
  spellbook: {
    createTitle: "Create Spellbook",
    createSubtitle: "Add a new spellbook to the Arts Genome",
    editTitle: "Edit Spellbook",
    editSubtitle: "Update spellbook domain details.",
    fieldLabel: "Spellbook (Domain)",
    fieldPlaceholder: "e.g., Music, Visual Art, Performing Arts, Design",
    saveLabel: "Save Spellbook",
    bulkColumnLabel: "Spellbook",
    bulkFail: "Failed to upload spellbooks",
    bulkTemplateFilename: "spellbook-bulk-template.csv",
    bulkTemplateExamples: ["Film", "Music", "Photography"],
    showUploadBulk: true,
    listTab: "spellbook",
  },
  class: {
    createTitle: "Create Class Type",
    createSubtitle: "Add a new class type to the Arts Genome",
    editTitle: "Edit Class Type",
    editSubtitle: "Update class type details.",
    fieldLabel: "Class Type",
    fieldPlaceholder: "e.g., Creator, Organizer, Supporter",
    saveLabel: "Save Class Type",
    bulkColumnLabel: "Class",
    bulkFail: "Failed to upload class types",
    bulkTemplateFilename: "class-bulk-template.csv",
    bulkTemplateExamples: ["Creator", "Organizer", "Supporter"],
    showUploadBulk: true,
    listTab: "class",
  },
  keyword: {
    createTitle: "Create Keyword Mapping",
    createSubtitle: "Add a new keyword mapping for the Arts Genome",
    editTitle: "Edit Keyword Mapping",
    editSubtitle: "Update keyword mapping details.",
    saveLabel: "Save Keyword Mapping",
    listTab: "keyword",
  },
}

export const getArtsGenomeItem = (type, itemId) => {
  const rows = ARTS_GENOME_ROWS[type] || []
  const row = rows.find(item => String(item.id) === String(itemId))

  if (!row) return null

  if (type === "keyword") {
    const publicRoleSlug =
      CLASS_ROWS.find(item => item.name === row.publicRole)?.slug ||
      row.classPrimary

    return {
      ...row,
      publicRoleSlug,
    }
  }

  return row
}

export { getInitials as getArtsGenomeInitials }

const CSV_HEADER_RE =
  /^(name|names|spellbook|class|class type|title|category)$/i

const parseCsvFirstCell = line => {
  const trimmed = String(line || "").trim()
  if (!trimmed) return ""

  if (trimmed.startsWith('"')) {
    let value = ""
    for (let i = 1; i < trimmed.length; i += 1) {
      const char = trimmed[i]
      const next = trimmed[i + 1]
      if (char === '"' && next === '"') {
        value += '"'
        i += 1
        continue
      }
      if (char === '"') break
      value += char
    }
    return value.trim()
  }

  return trimmed.split(",")[0].trim()
}

/**
 * Parse bulk CSV text → unique name list (first column).
 * Skips a header row when the first cell looks like a column title.
 */
export const parseArtsGenomeCsvNames = text => {
  const lines = String(text || "").split(/\r?\n/)
  const names = []
  const seen = new Set()

  lines.forEach((line, index) => {
    const value = parseCsvFirstCell(line)
    if (!value) return
    if (index === 0 && CSV_HEADER_RE.test(value)) return

    const key = value.toLowerCase()
    if (seen.has(key)) return
    seen.add(key)
    names.push(value)
  })

  return names
}

/** Escape a CSV cell (quotes when needed). */
const escapeCsvCell = value => {
  const text = String(value ?? "")
  if (/[",\n\r]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`
  }
  return text
}

/**
 * Build downloadable bulk CSV template text.
 * Header = column label; rows = example names (one per line).
 */
export const buildArtsGenomeCsvTemplate = ({
  columnLabel = "name",
  examples = [],
} = {}) => {
  const header = escapeCsvCell(columnLabel)
  const rows = (Array.isArray(examples) ? examples : [])
    .map(escapeCsvCell)
    .filter(Boolean)
  return [header, ...rows].join("\n")
}

/** Trigger browser download of the bulk CSV template. */
export const downloadArtsGenomeCsvTemplate = ({
  columnLabel = "name",
  examples = [],
  filename = "bulk-template.csv",
} = {}) => {
  if (typeof document === "undefined") return

  const csv = buildArtsGenomeCsvTemplate({ columnLabel, examples })
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" })
  const url = URL.createObjectURL(blob)
  const link = document.createElement("a")
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}

const formatCount = value => {
  const num = Number(value)
  if (!Number.isFinite(num)) return "--"
  return num.toLocaleString("en-US")
}

/** Map GET /api/v1/admin/role-types/summary → KPI cards. */
export const mapArtsGenomeSummaryKpi = (result = {}) => [
  {
    key: "spellbook",
    title: "Spellbook Categories",
    value: formatCount(result.spellbook_count),
    tone: "lightblue-custom",
  },
  {
    key: "class",
    title: "Class Types",
    value: formatCount(result.class_type_count),
    tone: "lightteal",
  },
  {
    key: "keyword",
    title: "Keyword Mappings",
    value: formatCount(result.keyword_mapping_count),
    tone: "purple-custom",
  },
]

export const ARTS_GENOME_SORT_OPTIONS = [
  { value: "name", label: "Name" },
  { value: "created_at", label: "Created At" },
  { value: "updated_at", label: "Updated At" },
]

export const DEFAULT_ARTS_GENOME_SORT_BY = "name"
export const DEFAULT_ARTS_GENOME_SORT_DIRECTION = "asc"

const pickName = value => {
  if (!value) return ""
  if (typeof value === "string") return value
  return value.name || value.public_name || ""
}

const pickSlug = value => {
  if (!value) return ""
  if (typeof value === "string") return value
  return value.slug || ""
}

/**
 * Map GET /api/v1/admin/role-types item → keyword mapping table row.
 */
export const mapKeywordMappingRow = item => {
  const spellbookName = pickName(item.spellbook)
  const spellbookSlug = pickSlug(item.spellbook) || item.spellbook_id || ""
  const secondarySpellbookName = pickName(item.secondary_spellbook)
  const secondarySpellbookSlug = pickSlug(item.secondary_spellbook)
  const className = pickName(item.role_class)
  const classSlug = pickSlug(item.role_class)
  const secondaryClassName = pickName(item.secondary_role_class)
  const secondaryClassSlug = pickSlug(item.secondary_role_class)

  return {
    id: item.id,
    roleInternal: item.name || "--",
    publicRole: item.public_name || item.name || "--",
    spellbook: spellbookName || "--",
    spellbookSlug: spellbookSlug || normalizePillToneKey(spellbookName),
    spellbookId: item.spellbook_id || item.spellbook?.id || "",
    spellbookSecondary: secondarySpellbookName || "",
    spellbookSecondarySlug:
      secondarySpellbookSlug || normalizePillToneKey(secondarySpellbookName),
    secondarySpellbookId:
      item.secondary_spellbook_id || item.secondary_spellbook?.id || "",
    classPrimary: className || "--",
    classSlug: classSlug || normalizePillToneKey(className),
    roleClassId: item.role_class_id || item.role_class?.id || "",
    classSecondary: secondaryClassName || "",
    classSecondarySlug:
      secondaryClassSlug || normalizePillToneKey(secondaryClassName),
    secondaryRoleClassId:
      item.secondary_role_class_id || item.secondary_role_class?.id || "",
    status: item.is_active === false ? "inactive" : "active",
    createdAt: item.created_at || "",
    updatedAt: item.updated_at || "",
    raw: item,
  }
}

/**
 * Collect unique spellbook / class options from role-type rows (for form selects).
 */
export const collectRoleTypeSelectOptions = (items = []) => {
  const spellbooks = new Map()
  const classes = new Map()

  items.forEach(item => {
    const sb = item.spellbook
    if (sb?.id && !spellbooks.has(sb.id)) {
      spellbooks.set(sb.id, {
        value: sb.id,
        label: sb.name || sb.slug || sb.id,
        slug: sb.slug || "",
      })
    }
    const ssb = item.secondary_spellbook
    if (ssb?.id && !spellbooks.has(ssb.id)) {
      spellbooks.set(ssb.id, {
        value: ssb.id,
        label: ssb.name || ssb.slug || ssb.id,
        slug: ssb.slug || "",
      })
    }
    const rc = item.role_class
    if (rc?.id && !classes.has(rc.id)) {
      classes.set(rc.id, {
        value: rc.id,
        label: rc.name || rc.slug || rc.id,
        slug: rc.slug || "",
      })
    }
    const src = item.secondary_role_class
    if (src?.id && !classes.has(src.id)) {
      classes.set(src.id, {
        value: src.id,
        label: src.name || src.slug || src.id,
        slug: src.slug || "",
      })
    }
  })

  return {
    spellbookOptions: [...spellbooks.values()].sort((a, b) =>
      a.label.localeCompare(b.label),
    ),
    classOptions: [...classes.values()].sort((a, b) =>
      a.label.localeCompare(b.label),
    ),
  }
}

/**
 * Map GET /api/v1/admin/spellbooks item → spellbook table row.
 */
export const mapSpellbookRow = item => {
  const name = item.name || "--"
  return {
    id: item.id,
    name,
    slug: item.slug || "",
    initials: getInitials(name),
    isActive: item.is_active !== false,
    createdAt: item.created_at || "",
    uploadedAt: item.updated_at || item.created_at || "",
    raw: item,
  }
}

/** Map GET /api/v1/admin/role-classes item → class table row. */
export const mapRoleClassRow = mapSpellbookRow

export const mapSpellbookSelectOptions = (items = []) =>
  (Array.isArray(items) ? items : []).map(item => ({
    value: item.id,
    label: item.name || item.slug || item.id,
    slug: item.slug || "",
  }))

export const mapRoleClassSelectOptions = mapSpellbookSelectOptions
